import {fileSize, imageFaceValidation, imageSize, size1024MB} from '../constant/variable';
import {
    IconDocx,
    IconJpeg,
    IconJpg,
    IconPdf,
    IconPng,
    IconPptx,
    IconSql,
    IconVideo,
    IconXlsx
} from '../components/buttons/IconButtons';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
export const FILE_TYPE = {
    IMAGE: {
        name: 'IMAGE',
        accept: 'image/*',
        size: imageSize,
        regex: /\.(jpg|jpeg|png|gif|JPG|JPEG|PNG)$/i

    },
    IMAGE_FACE_VALIDATION: {
        name: 'IMAGE',
        accept: 'image/*',
        size: imageFaceValidation,
        regex: /\.(jpg|jpeg|png|gif|JPG|JPEG|PNG)$/i

    },
    FILES: {
        name: 'FILES',
        size: fileSize,
        accept: '.pdf, .xlsx, .docx, .pptx',
        regex: /\.(pdf|xlsx|docx|pptx)$/i
    },
    VIDEOS: {
        name: 'VIDEOS',
        size: fileSize,
        accept: 'video/*',
        regex: /\.(mp4|mkv|avi|mov|flv|wmv|webm|mpeg|mpg|3gp|ogv)$/i
    },
    DATA_BASE: {
        name: 'DATA_BASE',
        size: size1024MB,
        accept: '.sql',
        regex: /\.sql$/i
    },
    IMAGE_FILES: {
        name: 'IMAGE_FILES',
        size: fileSize,
        accept: 'image/*, .pdf, .xlsx, .docx, .pptx',
        regex: /(\.(jpg|jpeg|png|gif|JPG|JPEG|PNG)|\.(pdf|xlsx|docx|pptx))$/i
    },
    IMAGE_FILES_VIDEOS: {
        name: 'IMAGE_FILES_VIDEOS',
        size: fileSize,
        accept: 'video/*, image/*, .pdf, .xlsx, .docx, .pptx',
        regex: /(\.(jpg|jpeg|png|gif|JPG|JPEG|PNG)|\.(mp4|mkv|avi|mov|flv|wmv|webm|mpeg|mpg|3gp|ogv)|\.(pdf|xlsx|docx|pptx))$/i
    },
    IMAGE_VIDEO: {
        name: 'IMAGE_VIDEO',
        accept: 'image/*, video/*',
        size: imageSize,
        regex: /(\.(jpg|jpeg|png|gif|JPG|JPEG|PNG)|\.(mp4|mkv|avi|mov|flv|wmv|webm|mpeg|mpg|3gp|ogv))$/i

    },
    XLSX: {
        name: 'XLSX',
        size: fileSize,
        accept: '.xlsx, .xls',
        regex: /\.(xlsx|xls)$/i
    },
};

export const FILES_ICON = {
    PDF: {
        extension: 'pdf',
        icon: IconPdf
    },
    XLSX: {
        extension: 'xlsx',
        icon: IconXlsx
    },
    DOCX: {
        extension: 'docx',
        icon: IconDocx
    },
    PPTX: {
        extension: 'pptx',
        icon: IconPptx
    },
    SQL: {
        extension: 'sql',
        icon: IconSql
    },
    JPG: {
        extension: 'jpg',
        icon: IconJpg
    },
    JPEG: {
        extension: 'jpeg',
        icon: IconJpeg
    },
    PNG: {
        extension: 'png',
        icon: IconPng
    },
};

export const getFileIcon = (file) => {
    const fileName = typeof file === 'string' ? file : file.name;
    const fileExtension = fileName?.split('.').pop()?.toUpperCase();

    if (!fileExtension) return null;

    if (FILE_TYPE.VIDEOS.regex.test(fileName)) {
        return IconVideo;
    }

    const fileType = Object.values(FILES_ICON).find(
        (type) => type.extension.toUpperCase() === fileExtension
    );

    return fileType ? fileType.icon : null;
};

export const isImage = (file) => {
    return FILE_TYPE.IMAGE.regex.test(file.name);
}

export const getFileNameWithoutExtension = (filename) => {
    return filename?.split('.').slice(0, -1).join('.') || filename;
};
